const formatDate = (isoString: string) => {
	const d = new Date(isoString);
	return d
		.toLocaleString("ru-RU", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		})
		.replace(",", "");
};

export default formatDate;
